import React from 'react';

import { Image } from '@uncinc/uncinc-react-kitchen-sink';

import type { SearchAllContentProfileHit as Type } from '../../../../SearchAllContent/types';
import constructVariableRatiosImageSourcesObject from '../../../../../helpers/constructImageSources';
import ProfileCard from '../../../../../implementations/Profile/Default/Card';
import avatar from '../../../../../assets/images/avatar.svg';

const MetaSearchProfileHit: React.FC<{ hit: Type }> = ({ hit }) => {
  const fullName = [hit.first_name[0], hit.last_name[0]].join(' ');
  const profileFunctions = hit.profile_functions_name?.join(', ');

  return (
    <ProfileCard
      title={fullName}
      subtitle={profileFunctions}
      image={hit.profile_image_ratio_1_1_xs ? (
        <Image
          src={constructVariableRatiosImageSourcesObject(
            hit,
            ['1_1', '1_1', '1_1', '1_1', '1_1'],
            ['xxs', 'xxs', 'xxs', 'xxs', 'xxs'],
          )}
          alt={hit.image_alt?.[0]}
          lazyload={false}
        />
      ) : (
        <img src={avatar} alt={fullName} />
      )}
      link={hit.url[0]}
      departments={hit.profile_departments_abbreviation}
      headOfDepartment={hit.head_of_department?.[0]}
    />
  );
};

export default MetaSearchProfileHit;
